module.exports = __webpack_public_path__ + "static/media/HowItWorkImage5.de1d6943.jpg";